module.exports = __webpack_public_path__ + "marker1ss.png?a8def9e58b62b1d27182a513c3bfd8d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marker1ss.png
// module id = 76
// module chunks = 0